import Model from "@/app/models/Concerns/Model";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class User extends Model {
    public role!: String;
    public project_id?: Number;

    public static async me(): Promise<Model> {
        const constructor = this as Function;
        const response: AxiosResponse<{ data: Model }> = await Client.get('/auth/me');

        // @ts-ignore
        return new constructor(response.data.data);
    }

    getTable(): string {
        return "users";
    }
}